import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./Login.css";
import { FaUserCircle } from "react-icons/fa";
import { IoIosLock } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import { getData } from "../../Store";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Login() {
  const [islogin, setIslogin] = useState(true);
  const [registerDone, setRegisterDone] = useState(true);
  const [emailError, setEmailError] = useState(false);
  const [passError, setPassError] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const navigate=useNavigate();
  const authData = useSelector((state) => {
    return state;
  });
  const dispatcher = useDispatch();

  useEffect(() => {
    dispatcher(getData());
  }, [dispatcher, registerDone]);

  const handleLogin = (email, pass) => {
    if (authData) {
      const employee = authData.find(
        (e) => e.email === email && e.password === pass
      );
      if (employee) {
        if(employee.role==="employee"){
          navigate(`/employee/${employee.id}`)
          setEmailError(false);
        }else if(employee.role==='admin'){
          navigate("/admin");
        }
      }
      else{
        setEmailError(true);
      }
    }
  };
  const handleRegister = (name, email, pass) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    if (emailRegex.test(email)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
    if (passwordRegex.test(pass)) {
      setPassError(false);
    } else {
      setPassError(true);
    }
    if (emailRegex.test(email) && passwordRegex.test(pass)){
      console.log(authData) ;
        axios.post("https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2",{
          id: authData.length + 1,
          name: name,
          password: pass,
          email: email,
          role:"employee",
          taskCounts: { active: 0, completed: 0, failed: 0, newTask: 0 },
          tasks: [],
        })
      setRegisterDone(!registerDone);
      alert("Registered successfully...");
      setIslogin(true);
    }
  };

  const loginHandler = (event) => {
    event.preventDefault();
    handleLogin(email, pass);
  };
  const registerHandler = (event) => {
    event.preventDefault();
    handleRegister(name, email, pass);
  };
  return (
    <div className="login_page container-fluid">
      <form
        className="login_form"
        onSubmit={islogin ? loginHandler : registerHandler}
      >
        <h2 className="login_heading">{islogin ? "Login" : "Register"}</h2>
        {!islogin && (
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FaUserCircle />
            </span>
            <input
              type="text"
              value={name}
              className="form-control inp1"
              placeholder="Enter Your Name"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        )}
        <div className="input-group mb-4">
          <span className="input-group-text">
            <FaUserCircle />
          </span>
          <input
            type="text"
            value={email}
            className="form-control inp1"
            placeholder="Enter Email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="input-group">
          <span className="input-group-text">
            <IoIosLock />
          </span>
          <input
            value={pass}
            type={showPass ? "text" : "password"}
            className="form-control inp1"
            placeholder="Enter Password"
            onChange={(e) => setPass(e.target.value)}
          />
          <span
            className="input-group-text eye_img"
            onMouseDown={() => setShowPass(true)}
            onMouseUp={() => setShowPass(false)}
          >
            {showPass ? <IoEye /> : <IoEyeOff />}
          </span>
        </div>

        {emailError &&  (
          <p className="error">Please Enter Email and Password</p>
        )}
        {passError && (
          <p className="error">Enter Strong password</p>
        )}
        <button type="submit" className="signUp mt-4">
          {islogin ? "Login" : "Register"}
        </button>
        <div className="d-flex justify-content-between">
          <p className="swipe">
            New here?{" "}
            {islogin ? (
              <span onClick={() => setIslogin(false)}>Sign up</span>
            ) : (
              <span onClick={() => setIslogin(true)}>Sign In</span>
            )}
          </p>
          <p className="forget">Forget password</p>
        </div>
      </form>
    </div>
  );
}

export default Login;
